<template>
  <div v-if="currentEmploye">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Contrat employé'"
          :description="'Nouveau contrat employé'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17">
                  <td class="col-12 text-center font-weight-bold">
                    Employé concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 d-flex justify-content-between">
                    <div>Nom : {{ currentEmploye.nom }}</div>
                    <div>
                      <router-link
                        :to="{
                          name: 'rh_employe-show',
                          params: { id: currentEmploye.id },
                        }"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                      </router-link>
                    </div>
                  </td>

                  <td class="col-6 font-weight-bold">
                    Prénom : {{ currentEmploye.prenom }}
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6">
                    Civilité : {{ currentEmploye.civilite.nom }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Matricule :
                    {{
                      currentEmploye.matricule
                        ? currentEmploye.matricule
                        : '###'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(prov).catch(() => {})"
        >
          Liste des contrats
        </button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>

        <div class="row">
          <div class="col-md-12">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Entrée
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="date_entree"
                      >Date d'entrée dans l'entreprise
                      <span class="text-danger">*</span>
                    </label>
                    <date-picker
                      v-model="form.date_entree"
                      name="date_entree"
                      placeholder="Date d'entrée dans l'entreprise"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_entree'),
                      }"
                      type="hidden"
                    />
                    <has-error :form="form" field="date_entree"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="date_debut"
                      >Date de début du contrat
                      <span class="text-danger">*</span></label
                    >
                    <date-picker
                      v-model="form.date_debut"
                      name="date_debut"
                      placeholder="Date de début du contrat"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_debut'),
                      }"
                      type="hidden"
                    />
                    <has-error :form="form" field="date_debut"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="salarie_statut"
                      >Statut du salarié
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="salarie_statut"
                      :options="salarieStatuts"
                      :reduce="(salarieStatut) => salarieStatut.uuid"
                      v-model="form.salarie_statut"
                      placeholder="Statut du salarié"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="salarie_statut"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('salarie_statut'),
                      }"
                    />
                    <has-error :form="form" field="salarie_statut"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="service"
                      >Service <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="service"
                      :options="services"
                      :reduce="(service) => service.uuid"
                      v-model="form.service"
                      placeholder="Service"
                    >
                      <template v-slot:option="{ nom, direction }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                        <span v-if="direction"
                          >Direction : {{ direction.nom }}</span
                        >
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="service"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('service'),
                      }"
                    />
                    <has-error :form="form" field="service"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="emploi_nature"
                      >Nature d'emploi <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="emploi_nature"
                      :options="emploiNatures"
                      :reduce="(emploiNature) => emploiNature.uuid"
                      v-model="form.emploi_nature"
                      placeholder="Nature d'emploi"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="emploi_nature"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('emploi_nature'),
                      }"
                    />
                    <has-error :form="form" field="emploi_nature"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="date_entree_profession"
                      >Date d'entrée dans la profession
                      <span class="text-danger">*</span>
                    </label>
                    <date-picker
                      v-model="form.date_entree_profession"
                      name="date_entree_profession"
                      placeholder="Date d'entrée dans la profession"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_entree_profession'),
                      }"
                      type="hidden"
                    />
                    <has-error
                      :form="form"
                      field="date_entree_profession"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="reference"
                      >Référence du contrat
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('reference') }"
                      id="reference"
                      v-model="form.reference"
                      type="text"
                      placeholder="Référence du contrat"
                      maxlength="50"
                    />
                    <has-error :form="form" field="reference"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="date_anciennete">Date d'ancienneté </label>
                    <date-picker
                      v-model="form.date_anciennete"
                      name="date_anciennete"
                      placeholder="Date d'ancienneté"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_anciennete'),
                      }"
                      type="hidden"
                    />
                    <has-error :form="form" field="date_anciennete"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="motif_entree"
                      >Motif d'entrée <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="motif_entree"
                      :options="motifEntrees"
                      :reduce="(motifEntree) => motifEntree.uuid"
                      v-model="form.motif_entree"
                      placeholder="Motif d'entrée"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="motif_entree"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('motif_entree'),
                      }"
                    />
                    <has-error :form="form" field="motif_entree"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="convention_collective"
                      >Convention collective
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="convention_collective"
                      :options="conventionCollectives"
                      :reduce="
                        (conventionCollective) => conventionCollective.uuid
                      "
                      v-model="form.convention_collective"
                      placeholder="Convention collective"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="convention_collective"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('convention_collective'),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="convention_collective"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="code_emploi"
                      >Code d'emploi <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('code_emploi') }"
                      id="code_emploi"
                      v-model="form.code_emploi"
                      type="text"
                      placeholder="Code d'emploi"
                      maxlength="50"
                    />
                    <has-error :form="form" field="code_emploi"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="situation_administrative"
                      >Situation administrative
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="situation_administrative"
                      :options="situationAdministratives"
                      :reduce="
                        (situationAdministrative) =>
                          situationAdministrative.uuid
                      "
                      v-model="form.situation_administrative"
                      placeholder="Situation administrative"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="situation_administrative"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has(
                          'situation_administrative'
                        ),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="situation_administrative"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="code_complement"
                      >Code complément <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('code_complement'),
                      }"
                      id="code_complement"
                      v-model="form.code_complement"
                      type="text"
                      placeholder="Code complément"
                      maxlength="50"
                    />
                    <has-error :form="form" field="code_complement"></has-error>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Emploi
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="contrat_type"
                      >Type de contrat <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="contrat_type"
                      :options="contratTypes"
                      :reduce="(contratType) => contratType.uuid"
                      v-model="form.contrat_type"
                      placeholder="Type de contrat"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="contrat_type"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('contrat_type'),
                      }"
                    />
                    <has-error :form="form" field="contrat_type"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="specificite"
                      >Spécificité du contrat
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="specificite"
                      :options="specificiteContrats"
                      :reduce="(specificite) => specificite.uuid"
                      v-model="form.specificite"
                      placeholder="Spécificité du contrat"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="specificite"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('specificite'),
                      }"
                    />
                    <has-error :form="form" field="specificite"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="caracteristique"
                      >Caractéristique du contrat
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('caracteristique'),
                      }"
                      id="caracteristique"
                      v-model="form.caracteristique"
                      type="text"
                      placeholder="Caractéristique du contrat"
                      maxlength="50"
                    />
                    <has-error :form="form" field="caracteristique"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="intitule"
                      >Intitulé du contrat
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('intitule') }"
                      id="intitule"
                      v-model="form.intitule"
                      type="text"
                      placeholder="Intitulé du contrat"
                      maxlength="50"
                    />
                    <has-error :form="form" field="intitule"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="ccn_statut_categorie"
                      >Statut catégoriel CCN
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="ccn_statut_categorie"
                      :options="ccnStatutCategories"
                      :reduce="(ccnStatutCategorie) => ccnStatutCategorie.uuid"
                      v-model="form.ccn_statut_categorie"
                      placeholder="Statut catégoriel CCN"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="ccn_statut_categorie"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('ccn_statut_categorie'),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="ccn_statut_categorie"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="emploi_multiple"
                      >Emploi multiples
                      <span class="text-danger">*</span></label
                    >
                    <div class="input-group">
                      <div
                        class="input-group-prepend bg-transparent"
                        @click="
                          form.emploi_multiple =
                            form.emploi_multiple - 1 > 0
                              ? form.emploi_multiple - 1
                              : 1
                        "
                      >
                        <span
                          class="input-group-text bg-transprent border-right-0"
                          role="button"
                        >
                          <i class="fas fa-minus text-danger"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control text-center"
                        :class="{
                          'is-invalid': form.errors.has('emploi_multiple'),
                        }"
                        id="emploi_multiple"
                        v-model.number="form.emploi_multiple"
                        placeholder="Emploi multiples"
                        required
                      />
                      <div
                        class="input-group-append bg-transparent"
                        @click="form.emploi_multiple++"
                      >
                        <span
                          class="input-group-text bg-transprent border-left-0"
                          role="button"
                        >
                          <i class="fas fa-plus text-success"></i>
                        </span>
                      </div>
                      <has-error
                        :form="form"
                        field="emploi_multiple"
                      ></has-error>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="date_fin_periode_essai"
                      >Date de fin période d'essai
                    </label>
                    <date-picker
                      v-model="form.date_fin_periode_essai"
                      name="date_fin_periode_essai"
                      placeholder="Date de fin période d'essai"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_fin_periode_essai'),
                      }"
                      type="hidden"
                    />
                    <has-error
                      :form="form"
                      field="date_fin_periode_essai"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="date_premier_annee"
                      >Date première année du contrat
                    </label>
                    <date-picker
                      v-model="form.date_premier_annee"
                      name="date_premier_annee"
                      placeholder="Date première année du contrat"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('date_premier_annee'),
                      }"
                      type="hidden"
                    />
                    <has-error
                      :form="form"
                      field="date_premier_annee"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="irc_statut_categorie"
                      >Statut catégoriel IRC
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="irc_statut_categorie"
                      :options="ircStatutCategories"
                      :reduce="(ircStatutCategorie) => ircStatutCategorie.uuid"
                      v-model="form.irc_statut_categorie"
                      placeholder="Statut catégoriel IRC"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="irc_statut_categorie"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('irc_statut_categorie'),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="irc_statut_categorie"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-6 col-lg-3 mt-n4 mt-lg-0">
                  <div class="custom-control custom-checkbox mt-4 pt-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="employeur_multiple"
                      v-model="form.employeur_multiple"
                    />
                    <label class="custom-control-label" for="employeur_multiple"
                      >Employeur multiples
                    </label>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-n4 mt-lg-0">
                  <div class="custom-control custom-checkbox mt-4 pt-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="statut"
                      v-model="form.statut"
                    />
                    <label class="custom-control-label" for="statut"
                      >Contrat en cours
                    </label>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-card class="text-black" header-class="bg-silver">
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-cube mr-0"></i> Paye
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="salaire"
                      >Salaire mensuel <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('salaire') }"
                      id="salaire"
                      v-model.number="form.salaire"
                      type="text"
                      placeholder="Salaire mensuel"
                    />
                    <has-error :form="form" field="salaire"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="heure_mensuelle"
                      >Heures mensuelles
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('heure_mensuelle'),
                      }"
                      id="heure_mensuelle"
                      v-model.number="form.heure_mensuelle"
                      type="text"
                      placeholder="Heures mensuelles"
                    />
                    <has-error :form="form" field="heure_mensuelle"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="heure_reference"
                      >Heures de référence
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('heure_reference'),
                      }"
                      id="heure_reference"
                      v-model.number="form.heure_reference"
                      type="text"
                      placeholder="Heures de référence"
                    />
                    <has-error :form="form" field="heure_reference"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="profil"
                      >Profil <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="profil"
                      :options="profils"
                      :reduce="(profil) => profil.uuid"
                      v-model="form.profil"
                      placeholder="Profil"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="profil"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('profil'),
                      }"
                    />
                    <has-error :form="form" field="profil"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="forfait_jour"
                      >Forfait en jours
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('forfait_jour') }"
                      id="forfait_jour"
                      v-model.number="form.forfait_jour"
                      type="text"
                      placeholder="Forfait en jours"
                    />
                    <has-error :form="form" field="forfait_jour"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="expression_temps_travail"
                      >Expression temps de travail
                      <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      label="nom"
                      id="expression_temps_travail"
                      :options="expressionTempsTravaux"
                      :reduce="
                        (expressionTempsTravail) => expressionTempsTravail.uuid
                      "
                      v-model="form.expression_temps_travail"
                      placeholder="Expression temps de travail"
                    >
                      <template v-slot:option="{ nom }">
                        <h5 style="margin: 0">{{ nom }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="expression_temps_travail"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has(
                          'expression_temps_travail'
                        ),
                      }"
                    />
                    <has-error
                      :form="form"
                      field="expression_temps_travail"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="classement_conventionnel"
                      >Classement conventionnel
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has(
                          'classement_conventionnel'
                        ),
                      }"
                      id="classement_conventionnel"
                      v-model="form.classement_conventionnel"
                      type="text"
                      placeholder="Classement conventionnel"
                      maxlength="50"
                    />
                    <has-error
                      :form="form"
                      field="classement_conventionnel"
                    ></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="niveau"
                      >Niveau <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('niveau'),
                      }"
                      id="niveau"
                      v-model="form.niveau"
                      type="text"
                      placeholder="Niveau"
                      maxlength="50"
                    />
                    <has-error :form="form" field="niveau"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="indice"
                      >Indice <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('indice'),
                      }"
                      id="indice"
                      v-model="form.indice"
                      type="text"
                      placeholder="Indice"
                      maxlength="50"
                    />
                    <has-error :form="form" field="indice"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="position"
                      >Position <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('position'),
                      }"
                      id="position"
                      v-model="form.position"
                      type="text"
                      placeholder="Position"
                      maxlength="50"
                    />
                    <has-error :form="form" field="position"></has-error>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="echelon"
                      >Echelon <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('echelon'),
                      }"
                      id="echelon"
                      v-model="form.echelon"
                      type="text"
                      placeholder="Echelon"
                      maxlength="50"
                    />
                    <has-error :form="form" field="echelon"></has-error>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_C from '@/http/rh/contrat';
import URL_E from '@/http/rh/employe';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: new Form({
        employe: null,
        date_entree: '',
        date_debut: '',
        salarie_statut: '',
        service: '',
        emploi_nature: '',
        date_entree_profession: '',
        reference: '',
        date_anciennete: '',
        motif_entree: '',
        convention_collective: '',
        code_emploi: '',
        situation_administrative: '',
        code_complement: '',
        contrat_type: '',
        specificite: '',
        caracteristique: '',
        intitule: '',
        ccn_statut_categorie: '',
        emploi_multiple: 0,
        date_fin_periode_essai: '',
        date_premier_annee: '',
        employeur_multiple: false,
        irc_statut_categorie: '',
        salaire: '',
        heure_mensuelle: 0,
        heure_reference: 0,
        profil: '',
        forfait_jour: 0,
        expression_temps_travail: '',
        classement_conventionnel: '',
        niveau: '',
        indice: '',
        position: '',
        echelon: '',
        statut: true,
      }),
      id: null,
      prov: this.$route.params.prov,
      salarieStatuts: [],
      services: [],
      emploiNatures: [],
      motifEntrees: [],
      conventionCollectives: [],
      situationAdministratives: [],
      contratTypes: [],
      specificiteContrats: [],
      ccnStatutCategories: [],
      ircStatutCategories: [],
      profils: [],
      expressionTempsTravaux: [],
      title: 'Gestion des contrats - Création',
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  computed: {
    ...mapGetters('employe', ['currentEmploye']),
  },
  components: {
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('employe', ['setCurrentEmploye']),
    init() {
      this.id = this.$route.params.id;
      this.setCurrentEmploye(null);
      this.salarieStatuts = [];
      this.services = [];
      this.emploiNatures = [];
      this.motifEntrees = [];
      this.conventionCollectives = [];
      this.situationAdministratives = [];
      this.contratTypes = [];
      this.specificiteContrats = [];
      this.ccnStatutCategories = [];
      this.ircStatutCategories = [];
      this.profils = [];
      this.expressionTempsTravaux = [];

      if (this.$route.params.filter === 'cloner') {
        window.axios
          .all([
            window.axios.get(
              URL_E.EMPLOYE + '/' + this.$route.params.employeId
            ),
            window.axios.get(URL_C.CONTRAT + '/' + this.id, {
              params: {
                edit: true,
              },
            }),
            window.axios.get(URL_C.GET_REQUIREMENTS),
          ])
          .then(
            window.axios.spread((resp1, resp2, resp3) => {
              this.setCurrentEmploye(resp1.data.employe);

              Object.assign(this.form, resp2.data.contrat);

              this.salarieStatuts = resp3.data.salarie_statuts;
              this.services = resp3.data.services;
              this.emploiNatures = resp3.data.emploi_natures;
              this.motifEntrees = resp3.data.motif_entrees;
              this.conventionCollectives = resp3.data.convention_collectives;
              this.situationAdministratives =
                resp3.data.situation_administratives;
              this.contratTypes = resp3.data.contrat_types;
              this.specificiteContrats = resp3.data.specificite_contrats;
              this.ccnStatutCategories = resp3.data.ccn_statut_categories;
              this.ircStatutCategories = resp3.data.irc_statut_categories;
              this.profils = resp3.data.profils;
              this.expressionTempsTravaux = resp3.data.expression_temps_travaux;

              delete this.form.id;
              delete this.form.uuid;
            })
          )
          .catch();
      } else {
        window.axios
          .all([
            window.axios.get(
              URL_E.EMPLOYE + '/' + this.$route.params.employeId
            ),
            window.axios.get(URL_C.GET_REQUIREMENTS),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.setCurrentEmploye(resp1.data.employe);
              this.salarieStatuts = resp2.data.salarie_statuts;
              this.services = resp2.data.services;
              this.emploiNatures = resp2.data.emploi_natures;
              this.motifEntrees = resp2.data.motif_entrees;
              this.conventionCollectives = resp2.data.convention_collectives;
              this.situationAdministratives =
                resp2.data.situation_administratives;
              this.contratTypes = resp2.data.contrat_types;
              this.specificiteContrats = resp2.data.specificite_contrats;
              this.ccnStatutCategories = resp2.data.ccn_statut_categories;
              this.ircStatutCategories = resp2.data.irc_statut_categories;
              this.profils = resp2.data.profils;
              this.expressionTempsTravaux = resp2.data.expression_temps_travaux;
            })
          )
          .catch();
      }
    },

    submit() {
      this.form.employe = this.currentEmploye.uuid;

      this.form
        .post(URL_C.CONTRAT)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.id) {
            this.id = null;
          }
          this.$router.push({
            name: 'rh_employe_contrat-show',
            params: {
              id: resp.data.contrat.id,
              employeId: this.currentEmploye.id,
              prov: this.prov,
            },
          });
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
